import React from "react";
import { Helmet } from "react-helmet-async";
import { IOS_URL, ANDROID_URL } from "../constants/storeLinks";

const BASE = "https://www.nekochan.app";

function JsonLd({ data }) {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}

export function OrganizationSchema() {
  return (
    <JsonLd
      data={{
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Nekochan",
        legalName: "Nekochan S.A.",
        url: BASE,
        logo: `${BASE}/images/logo.svg`,
        sameAs: [
          "https://x.com/NekochanApp",
          "https://instagram.com/nekochanapp/",
          "https://tiktok.com/@nekochanapp",
          "https://youtube.com/@NekochanApp",
        ],
        contactPoint: {
          "@type": "ContactPoint",
          email: "help@nekochan.app",
          contactType: "customer support",
        },
      }}
    />
  );
}

export function SoftwareApplicationSchema() {
  return (
    <JsonLd
      data={{
        "@context": "https://schema.org",
        "@type": "MobileApplication",
        name: "Nekochan",
        description:
          "Learn Japanese vocabulary with spaced-repetition flashcards, anime-style lessons, and an AI study companion. 1,000+ words, available in English and Spanish.",
        applicationCategory: "EducationalApplication",
        operatingSystem: "iOS, Android",
        url: BASE,
        downloadUrl: [IOS_URL, ANDROID_URL],
        offers: {
          "@type": "Offer",
          price: "0",
          priceCurrency: "USD",
          description: "Free with optional Pro subscription",
        },
        inLanguage: ["en", "es"],
        author: {
          "@type": "Organization",
          name: "Nekochan S.A.",
        },
      }}
    />
  );
}

export function FAQPageSchema({ faqs }) {
  if (!faqs || !Array.isArray(faqs) || faqs.length === 0) return null;
  return (
    <JsonLd
      data={{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer,
          },
        })),
      }}
    />
  );
}

export function WebSiteSchema() {
  return (
    <JsonLd
      data={{
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "Nekochan",
        url: BASE,
        inLanguage: ["en", "es"],
      }}
    />
  );
}
